<style lang="scss" src="./SolicitudesPendientesLista.scss"></style>
<template src="./SolicitudesPendientesLista.html"></template>

<script>
// import csvToJson from "convert-csv-to-json";
// import csvToJson from "@/components/Shared/ExportToFile/ExportToJSON"
import papa from 'papaparse'
import { EstadoSolicitud } from "@/enums/estadoSolicitud";
import SolicitudesPendientesTabla from "@/components/PartidoPolitico/Solicitudes/SolicitudesPendientes/SolicitudesPendientesTabla/SolicitudesPendientesTabla";
import { Breadcrumb, BreadcrumbItem, Button, Dialog } from "element-ui";
import ExportToFile from "@/components/Shared/ExportToFile/ExportToFile";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import moment from "moment-timezone";
import { FechaMaximaReclamacionMixin } from "@/mixins/FechaMaximaReclamacionMixin";
import { requestRevisionMixin } from "@/api/partidoPolitico/revisionApi";
import { NotifyMixin } from "@/mixins/NotifyMixin";
import { ExportToFileMixin } from "@/mixins/exportToFile";
import { RouterMixin } from "@/mixins/routerMixin";
import { BrotliMixin } from "@/mixins/BrotliMixin";

import { utils } from "@/utils";

export default {
  name: "SolicitudesPendientesLista",
  components: {
    SolicitudesPendientesTabla,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    ExportToFile,
  },
  mixins: [
    requestRevisionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    FechaMaximaReclamacionMixin,
    ExportToFileMixin,
    RouterMixin,
    BrotliMixin,
  ],
  data: () => ({
    loading: false,
    errored: false,
    inRoute: false,
    dlgExportToFile: false,
    querySearch: "",
    dateFilter: [],
    header: [
      "Solicitudes de Afiliación",
      "Rut",
      "Nombres",
      "Apellido Paterno",
      "Apellido Materno",
      "Fecha Nacimiento",
      "Correo electrónico",
      "Teléfono móvil",
      "Teléfono fijo",
      "Región",
      "Comuna",
      "Domicilio",
      "Fecha de ingreso",
      "Tipo",
      "Estado de la Solicitud",
    ],
    filter: [
      "id",
      "run",
      "nombres",
      "paterno",
      "materno",
      "fechanacimiento",
      "email",
      "telefonomovil",
      "telefonofijo",
      "region",
      "comuna",
      "domicilio",
      "fechacompleta",
      "tipo_afiliacion",
      "estado",
    ],
    disabled: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
    ],
  }),
  computed: {
    fieldsToExport: function () {
      const list = this.header.map((h, i) => ({
        name: h,
        key: this.filter[i],
        disabled: this.disabled[i],
      }));
      this.$log.debug(list);
      return list;
    },
  },
  beforeMount() {
    if (this.$route.name === "solicitud-pendientes") {
      this.inRoute = true;
    }
  },
  methods: {
    verSolicitud(id, estado) {
      this.$log.debug("table onVerSolicitud", id, estado);
      if (estado === EstadoSolicitud.revisionpp) {
        this.navigate({ name: "revision-id", params: { id: id } });
      } else if (estado === EstadoSolicitud.reclamacion) {
        this.navigate({ name: "reclamacion-id", params: { id: id } });
      }
    },
    exportToFile(querySearch = "", dateFilter = []) {
      this.$log.debug("exportToFile", querySearch, dateFilter);
      this.querySearch = querySearch;
      this.dateFilter = dateFilter;

      this.dlgExportToFile = true;
    },
    closeDlgExport() {
      this.dlgExportToFile = false;
    },
    async checkSelection(tableData) {
      this.$confirm(
        "Aprobará las solicitudes de afiliación seleccionadas, ¿Está seguro de que desea continuar?",
        "Portal Afiliación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          await this.enviarSelectionRevisionSolicitud(tableData);
        })
        .catch(() => {
          this.showInfo(
            "Canceló la aprobación de las solicitudes seleccionadas."
          );
        });
    },
    async checkAll(querySearch = "", dateFilter = []) {
      this.$confirm(
        "Aprobará todas las solicitudes de afiliación, ¿Está seguro de que desea continuar?",
        "Portal Afiliación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          const listField = ["id"];
          const datasource = await this.listaAfiliacion({
            querySearch: querySearch,
            dateFilter: dateFilter,
            fields: listField,
          });
          await this.enviarSelectionRevisionSolicitud(datasource);
        })
        .catch(() => {
          this.showInfo("Canceló la aprobación de todas las solicitudes.");
        });
    },
    async generarData(tableData) {
      let data = {};

      await this.fechaMaximaReclamacion();

      data.listaAfiliacion = tableData.map((td) => td.id);
      data.plazoMaxReclamo = this.model.fechaMaxima;
      return data;
    },
    async enviarSelectionRevisionSolicitud(tableData) {
      const loading = this.getLoading();

      const data = await this.generarData(tableData);
      this.$log.debug("enviarSelectionRevisionSolicitud", data);

      this.crearSelectionRevision(data)
        .then((response) => {
          this.$log.debug("crearSelectionRevision", response.data.statusCode);
          loading.close();

          if (response.data.statusCode === 201) {
            this.querySearch = "";
            this.dateFilter = [];
            this.showSuccess("La revisiones se han ingresado correctamente");
          } else if (response.data.statusCode === 404) {
            this.showInfo("No se encontraron afiliaciones para aprobar");
          } else {
            this.showError(
              "Ocurrió un error inesperado al enviar la revisiones"
            );
          }

          this.$refs.solicitudesPendientesTabla.refreshTabla();
        })
        .catch((err) => {
          this.$log.fatal(
            "crearSelectionRevision",
            err,
            err.response,
            err.request
          );
          loading.close();
          this.showError("No se ha podido ingresar las revisiones");
        });
    },
    async exportToExcel(checkList, fields) {
      this.$log.debug("exportToExcel");
      const listField = this.getListField(checkList, fields);
      const data = await this.listaAfiliacion({ fields: listField });
      if (!this.errored) {
        const date = moment(new Date()).format("YYYYMMDDhhmmss");
        const filename = `solicitudes-pendientes-${date}`;
        this.exportExcel(data, checkList, fields, filename);
      }
    },
    async exportToPdf(checkList, fields) {
      this.$log.debug("exportToPdf", checkList, fields);
      const listField = this.getListField(checkList, fields);
      this.$log.debug("exportToPdf listField", listField);
      const data = await this.listaAfiliacion({ fields: listField });

      if (!this.errored) {
        const date = moment(new Date()).format("YYYYMMDDhhmmss");
        const filename = `solicitudes-pendientes-${date}`;
        const title = "Solicitud de afiliación pendientes";
        this.exportPdf(data, checkList, fields, filename, title);
      }
    },
    listaAfiliacion({
      pageAll = true,
      search = this.querySearch,
      dateRange = this.dateFilter,
      fields = fields,
      format = "csv",
      compress = true,
    } = {}) {
      this.loading = true;
      const pagingQuery = {
        pageAll: pageAll,
        search: search,
        dateRange: dateRange,
        fields: fields,
        format: format,
        compress: compress,
      };

      const loading = this.getLoading();

      return this.getListaAfiliacionRevision(pagingQuery)
        .then((response) => {
          this.$log.debug(
            "getListaAfiliacionRevision",
            response.data.statusCode
          );

          if (response.data.statusCode === 200) {
            const data = this.decompress(response.data.datos);
            let dataformat = data;
            if (pagingQuery.format === "csv") {
              // dataformat = csvToJson.fieldDelimiter(";").csvStringToJson(data);
              dataformat =  papa.parse(data)
            }

            const datasource = dataformat.data.map((row) => {
              row.run = utils.rutFilter(row.run);
              return row;
            });

            this.$log.debug(datasource);
            this.errored = false;

            return datasource;
          } else {
            this.errored = true;
            this.showError("Ocurrió un error inesperado al cargar los datos");
          }
          return [];
        })
        .catch((err) => {
          this.$log.fatal(
            "getListaAfiliacionRevision",
            err,
            err.response,
            err.request
          );
          this.errored = true;
          this.showError("Ocurrió un error inesperado al cargar los datos");
        })
        .finally(() => {
          this.loading = false;
          loading.close();
        });
    },
  },
};
</script>
